var map = {
	"./gold_symbol_0.png": 29749,
	"./gold_symbol_1.png": 77484,
	"./gold_symbol_2.png": 96487,
	"./gold_symbol_3.png": 27646,
	"./gold_symbol_4.png": 10737,
	"./gold_symbol_5.png": 16872,
	"./gold_symbol_6.png": 53731,
	"./gold_symbol_7.png": 89626,
	"./gold_symbol_8.png": 47405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61762;